import { render, staticRenderFns } from "./PortfolioFreightUsage.vue?vue&type=template&id=4273a5ac&"
import script from "./PortfolioFreightUsage.vue?vue&type=script&lang=js&"
export * from "./PortfolioFreightUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports